module.exports = __webpack_public_path__ + "static/media/logo512x512.23487dfd.png";